<template>
  <div @click="select">
    <ItemImage v-if="value" :item=value :size="imageSize" />
    <i class="empty" :style="{'padding-top': sizeratio}" :class="'size-' + imageSize" v-else></i>
    <button class="btn" type="button">
      <template v-if="value">
        {{ 'images:attach.title' | trans }}
      </template>
      <template v-else>
        {{ 'images:attach.title_add' | trans }}
      </template>
    </button>
  </div>
</template>

<script>
  import {abstractField} from "vue-form-generator";
  import ItemImage from '@/helpers/components/display/ItemImage'
  import ImageBrowser from '@/helpers/components/interact/ImageBrowser'
  import ModalDialogs from 'vue-modal-dialogs'
  // Make a dialog function
  const selectfromgallery = ModalDialogs.makeDialog(ImageBrowser, 'current')
  
  export default {
    name: 'field-imageselect',
    mixins: [abstractField],
    components: {ItemImage},
    data () {return {
      selectfromgallery,
      browse: false,
    }},
    computed: {
      imageSize () {
        if (this.schema.hasOwnProperty('size')) {
          return this.schema.size;
        }
        return 1;
      },
      sizeratio () {
        if (Array.isArray(this.imageSize)) {
          return String(this.imageSize[1]/this.imageSize[0]*100) + '%';
        } else {
          switch (this.imageSize) {
            case 2:
              return '50%';
            default:
              return '100%';
          }
        }
      }
    },
    mounted () {
      this.setValue();
    },
    watch: {
      value (val) {
        if (val === undefined) {
          this.setValue();
        }
      }
    },
    methods: {
      select () {
        return this.selectfromgallery(this.value)
          .then(result => {
            if (typeof result !== 'undefined') {
              this.value = result;
            }
            return result;
          })
        ;
      },
      setValue () {
        if (!this.value && this.model && this.model.images) {
          var attachment_type = this.schema.model === 'image' ? 'main' : this.schema.model;
          var filtered = this.model.images
            .filter(i => !i.pivot || !i.pivot.attachment_type || i.pivot.attachment_type === attachment_type)
          ;
          if (filtered.length) {
            this.value = filtered.pluck(0);
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .btn {
    display: block;
    width: 100%;
  }
  i.empty {
    display: block;
    background: $body-bg;
    padding-top: 100%;
    &.size-2 {
      padding-top: 50%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/helpers/mixins/form/ImageSelect.vue